import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, AlertController, ToastController, ActionSheetController, ModalController, LoadingController, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HomePage } from '../pages/home/home';
// import { LoginPage } from '../pages/login/login';
import { AppSettings } from '../services/app-settings';
import { AppVersion } from '@ionic-native/app-version';
import { Network } from '@ionic-native/network';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { LocalNotifications } from '@ionic-native/local-notifications';


import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { ServerService } from '../services/server-service';
import { ToastService } from '../services/toast-service';

declare var cordova: any;

@Component({
  templateUrl: 'app.html'
})


export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any;
  pages: Array<{ title: string, component: any, icon: string }>;
  previousConnectionStatus: any = 'ONLINE';
  firebasePlugin;
  appCurrentVersion: any = '';
  ticketsList: any = [];
  constructor(public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen, private appVersion: AppVersion,
    private alertCtrl: AlertController, private network: Network, private toastCtrl: ToastController,
    private iab: InAppBrowser,
    private barcodeScanner: BarcodeScanner,
    private androidPermissions: AndroidPermissions,
    private api: ServerService,
    public modalCtrl: ModalController,
    private toast: ToastService,
    public actionSheetCtrl: ActionSheetController,
    public loadingCtrl: LoadingController,
    private localNotifications: LocalNotifications,
    private events: Events) {
    this.events.subscribe('user:blocked', () => {
      this.showBlockedUserAlert();
    });
    this.initializeApp();

    this.pages = [
      { title: 'ראשי', component: 'HomePage', icon: 'home-outline' },
      { title: 'אירועים', component: 'EventsPage', icon: 'calendar-outline' },
      { title: 'סריקה', component: 'ScanticketsPage', icon: 'qr-scanner-outline' },
      { title: 'סריקת כרטיס/יות בפריטים', component: 'ScanproductPage', icon: 'qr-scanner-outline' },
      { title: 'פניות', component: 'MessagesPage', icon: 'mail-outline' },
      { title: 'קריאת שירות', component: 'supportMenu', icon: 'alert-outline' },
      { title: 'הגדרות', component: 'SettingsPage', icon: 'settings-outline' },
      { title: 'התנתקות', component: 'LogOut', icon: 'exit-outline' },
    ];

  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.checkVersion();
      this.initializeNetworkEvents();
      this.statusBar.overlaysWebView(false);

      // Track cold-start app launches so the rate-app modal can appear from the 2nd run on.
      try {
        const raw = localStorage.getItem('rateModalAppLaunches');
        const current = raw ? parseInt(raw, 10) : 0;
        const next = isNaN(current) ? 1 : current + 1;
        localStorage.setItem('rateModalAppLaunches', String(next));
      } catch (e) { /* noop */ }

      let userid = localStorage.getItem('user_id');
      let scannerOptions = localStorage.getItem('scannerOptions');
      if (!scannerOptions) {
        localStorage.setItem('scannerOptions', '0');
      }

      if (userid && userid != "undefined") {
        this.nav.setRoot(HomePage);
      } else {
        this.nav.setRoot('LoginPage');
      }

      let beitEmonoalRamatGanServer = localStorage.getItem("beitEmonoalRamatGanServer");

      if (!beitEmonoalRamatGanServer) {
        localStorage.setItem("beitEmonoalRamatGanServer", "0");
      }



      this.firebasePlugin = (<any>window).FirebasePlugin;

      if (this.platform.is('cordova')) {
        if (this.platform.is('android')) {


          this.requestPushNotificationPermission();
          this.initializeFireBaseAndroid();

          this.localNotifications.requestPermission().then((pushRequestData) => {
            console.log("requestPermission", pushRequestData)
          }, (pushRequestDataError => {
            console.log("requestPermission", pushRequestDataError)
          }));


        }
        if (this.platform.is('ios')) {
          this.initializeFireBaseIos();
        }
      }

      this.platform.registerBackButtonAction(() => {
        if (this.nav.length() == 1) {
          let alert = this.alertCtrl.create({
            title: 'אישור יציאה מהאפליקציה',
            //message: 'Do you want to exit?',
            buttons: [
              {
                text: "יציאה", handler: () => {
                  this.platform.exitApp();
                }
              },
              { text: "ביטול", role: 'cancel' }
            ]
          });
          alert.present();

        } else
          this.nav.pop();

      });

    });
  }

  async checkVersion() {

    await this.appVersion.getVersionNumber().then((version) => {
      this.appCurrentVersion = version;
      let appPlatform = this.platform.is('android') ? 'android' : 'ios';
      fetch(AppSettings.APP_VERSION + '?platform=' + appPlatform)
        .then(response => response.json())
        .then(data => {
          let remote_version = data['app_version'];
          if (remote_version > version) {
            let alertBox = this.alertCtrl.create({
              title: '<b>עידכון קיים</b>',
              subTitle: 'עידכון גרסה: ' + remote_version + ' זמין להורדה',
              buttons: [
                {
                  text: 'ביטול',
                  role: 'cancel',
                  handler: () => {
                    console.log('Cancel clicked');
                  }
                },
                {
                  text: 'הורדה',
                  handler: () => {
                    let downloadlink = '';
                    if (this.platform.is('android')) {
                      downloadlink = 'https://play.google.com/store/apps/details?id=com.matnasnet.matnasnet';
                    } else {
                      downloadlink = 'https://apps.apple.com/us/app/matnasnet/id1542235552';
                      // downloadlink = 'itms-apps://itunes.apple.com/app/1542235552';
                    }
                    if (downloadlink) {
                      // window.open(downloadlink, '_system', 'location=yes');
                      const browser = this.iab.create(downloadlink, '_system');
                    }
                  }
                }
              ]
            });
            alertBox.present();
          }
        })
        .catch((apiError => {
        }));

    }, (versionError) => {
      console.log(versionError);
    });
  }

  private initializeFireBaseAndroid(): Promise<any> {

    return this.firebasePlugin.getToken(token => {
      this.firebasePlugin.getToken(token => {
        this.sendPushtoserver(token);
        this.firebasePlugin.subscribe("all");
        this.subscribeToPushNotificationEvents();
      });
    });
  }

  private initializeFireBaseIos(): Promise<any> {

    return this.firebasePlugin.grantPermission(data => {
      this.firebasePlugin.getToken(token => {
        this.sendPushtoserver(token);
        this.firebasePlugin.subscribe("all");
        this.subscribeToPushNotificationEvents();
      });
    });
  }



  subscribeToPushNotificationEvents() {
    // Handle token refresh

    this.firebasePlugin.onTokenRefresh((token) => {
      this.sendPushtoserver(token);
    });


    this.firebasePlugin.onMessageReceived((notification) => {

      if (!notification.tap) {
        //alert(JSON.stringify(notification));
      }
      else {
        // if (notification.type == "update_status") {
        //     // this.nav.push('DetailsPage', {
        //     //     id: notification.tracking_number
        //     // });
        // }
        //alert(JSON.stringify(notification));
      }
    })
  }


  async sendPushtoserver(token) {
    if (token) {
      // this.config.SetUserPush(token);
      localStorage.setItem("push", token);
      // await this.server.SavePush("save_push.php", token).then((data: any) => {
      // });
    }
  }


  requestPushNotificationPermission() {
    if (this.platform.is('android')) {
      var permissions = cordova.plugins.permissions;

      permissions.requestPermission(permissions.POST_NOTIFICATIONS,
        function (status) {
          if (status.hasPermission) {
            console.log("Push notification permission granted!");
          } else {
            console.warn("Push notification permission denied!");
          }
        },
        function (error) {
          console.error("Error requesting push notification permission", error);
        }
      );

    }
  }


  public initializeNetworkEvents(): void {
    this.network.onDisconnect().subscribe(() => {
      if (this.previousConnectionStatus == "ONLINE") {
        this.presentToast("מתונק מהאינטרנט");
      }
      this.previousConnectionStatus = "OFFLINE";
    });
    this.network.onConnect().subscribe(() => {
      if (this.previousConnectionStatus == "OFFLINE") {
        this.presentToast("מחובר לאינטרנט");
      }
      this.previousConnectionStatus = "ONLINE";
    });

    this.network.onchange().subscribe(() => {

      setTimeout(() => {
        if (this.network.type === '2g' || this.network.type === '3g' || this.network.type === 'unknown') {
          this.presentToast("חיבור אינטרנט איטי מהרגיל");
        }
      }, 3000);

    });
  }



  logout() {
    localStorage.removeItem("mercazName");
    localStorage.removeItem("userName");
    localStorage.removeItem("password");
    localStorage.removeItem("user_id");
    localStorage.removeItem("mercazAllId");
    localStorage.setItem("beitEmonoalRamatGanServer", "0");
    this.nav.setRoot('LoginPage');
  }

  showBlockedUserAlert() {
    const alertBox = this.alertCtrl.create({
      title: 'המשתמש חסום',
      message: 'אנא פנה לתמיכה',
      buttons: [
        {
          text: 'אישור',
          handler: () => {
            this.logout();
          }
        }
      ]
    });
    alertBox.present();
  }

  openPage(page) {
    console.log("page", page);
    if (page.title == "התנתקות") {

      let alertBox = this.alertCtrl.create({
        title: '<b>האם לאשר התנתקות מהמערכת?</b>',
        subTitle: '',
        buttons: [
          {
            text: 'ביטול',
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          },
          {
            text: 'יציאה',
            handler: () => {
              this.logout();
            }
          }
        ]
      });
      alertBox.present();
    }

    else if (page.title == "קריאת שירות") {


      // let alertBox = this.alertCtrl.create({
      //   title: '<b>קריאת שירות</b>',
      //   subTitle: '',
      //   buttons: [
      //     {
      //       text: 'ביטול',
      //       role: 'cancel',
      //       handler: () => {
      //         console.log('Cancel clicked');
      //       }
      //     },
      //     {
      //       text: 'קריאה כללית',
      //       handler: () => {
      //         this.nav.push('SupportrequestPage');
      //       }
      //     }
      //   ]
      // });
      // alertBox.present();

      this.nav.push('SupportrequestPage');


      // const actionSheet = this.actionSheetCtrl.create({
      //   title: 'קריאת שירות',
      //   cssClass: 'action-sheet-ios',
      //   buttons: [
      //     {
      //       text: 'קריאה כללית',
      //       // icon: 'document-outline',
      //       handler: () => {
      //         this.nav.setRoot('SupportrequestPage');
      //       }
      //     }, {
      //       text: 'ביטול',
      //       role: 'cancel',
      //       // icon: 'exit-outline',
      //       handler: () => {
      //         console.log('Cancel clicked');
      //       }
      //     }
      //   ]
      // });
      // actionSheet.present();
    }
    else if (page.title == "ראשי") {
      this.nav.setRoot(HomePage);
    }
    else {
      this.nav.push(page.component);
    }
  }

  presentToast(text) {
    let toast = this.toastCtrl.create({
      message: text,
      duration: 3000,
      position: 'bottom'
    });

    toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });

    toast.present();
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts